import { Moment } from "moment";
import { ICharacteristicValue } from "rl-common/models/i-characteristic-value";

export interface IFinancialPeriod {
	id: number;
	year: number;
	period: number;
	startDate: string;
	endDate: string;
	status: FinancialPeriodStatus;
	sid: number;
}

export enum FinancialPeriodStatus {
	Open,
	Locked
}

export interface IClosedPeriodSettings {
	availableActions: [number[]];
	selectedActions: number[];
}

export interface IFilterablePeriod {
	endDate?: string;
	endMonth?: string;
	endMonthString?: string;
	endYear?: string;
	sid?: string;
	startMoment: Moment;
	endMoment: Moment;
	matchingLov: ICharacteristicValue
}

export interface IPeriodClosedOpenMetadata {
	maxClosedPeriod: IFinancialPeriod | null;
	minOpenPeriod: IFinancialPeriod | null;
}